import { jobBoardAPI } from './base';

export const LOGIN = async (userPayLoad: {
  email: string;
  password: string;
}): Promise<any> => {
  return jobBoardAPI.post('auth/login', userPayLoad);
};

export const FORGET_PASSWORD = async (forgetPasswordDto: {
  email: string;
}): Promise<any> => {
  return jobBoardAPI.post('auth/forgetPassword', forgetPasswordDto);
};

export const CHANGE_PASSWORD = async (changePasswordDto: {
  email: string;
  token: number;
  password: string;
  confirmPassword: string;
}): Promise<any> => {
  return jobBoardAPI.post('auth/changePassword', changePasswordDto);
};

export const GET_MICROSOFT_LOGIN_URL = async (state?: string): Promise<any> => {
  const params = state ? { state } : {};
  return jobBoardAPI.get('auth/microsoft-auth/login', {
    params
  } as any);
};

export const EXCHANGE_MICROSOFT_SESSION_CODE = async (
  sessionCode: string
): Promise<any> => {
  return jobBoardAPI.post('auth/microsoft-auth/token/exchange', {
    sessionCode
  });
};

export const GET_MICROSOFT_USER_INFO = async (): Promise<any> => {
  return jobBoardAPI.get('auth/microsoft-auth/me');
};

export const LOGOUT = async (): Promise<any> => {
  return jobBoardAPI.post('/auth/microsoft-auth/logout', {});
};

export const GET_CSRF_TOKEN = async (): Promise<any> => {
  return jobBoardAPI.get('auth/csrf');
};
